type TBrowserSessionId = string | null;

export class BrowserSessionService {
  private sessionId: TBrowserSessionId = null;
  private storageKey: string = "BrowserSessionIdKey_default";

  constructor(storageKey: string) {
    this.setStorageKey(storageKey);
    this.setSessionId(this.getSessionIdFromStore());
  }

  public setSessionId(sessionId: TBrowserSessionId): boolean {
    this.sessionId = sessionId;
    if (!sessionId) {
      return false;
    }

    window.sessionStorage.setItem(this.storageKey, sessionId);
    return true;
  }

  public getSessionId(): TBrowserSessionId {
    return this.sessionId;
  }

  public setStorageKey(storageKey: string): boolean {
    this.storageKey = storageKey;
    return true;
  }

  public setOnWindowSessionId(): boolean {
    if (!this.sessionId) {
      return false;
    }
    window.name = this.sessionId;
    return true;
  }

  public getGeneratedSessionId(): string {
    return String(Date.now());
  }

  public isSameBrowserSession(): boolean {
    const sessionId = this.getSessionId();
    return window.name === sessionId;

  }

  public clearBrowserSession() {
    this.sessionId = null;
    window.sessionStorage.removeItem(this.storageKey);
    window.name = "";
  }

  private getSessionIdFromStore(): string | null {
    return window.sessionStorage.getItem(this.storageKey);
  }
}
